module.exports = __webpack_public_path__ + "img/benefit-5-hover.34ebcc31.png";